/** ジオフェンスのポリゴン */
export type ShipmentGeofencePolygonDto = {
  /** 緯度 */
  latitude: number;
  /** 経度 */
  longitude: number;
};

/** 配送位置情報のジオフェンス */
export type ShipmentGeofenceDto = {
  /** ジオフェンスタイプ */
  geofenceType: 'circle' | 'polygon';
  /** 円の半径（元の指定した値） */
  circleRadius?: number;
  /** 円の半径の単位 */
  circleRadiusUnit?: string;
  /** 円の半径（メートル単位） */
  circleRadiusInMeters?: number;
  /** ポリゴンリスト */
  polygonList?: ShipmentGeofencePolygonDto[];
};

/** 円の半径のデフォルト（メートル単位） */
export const DEFAULT_RADIUS_METERS = 200;

/** 配送位置情報のレスポンス内容 */
export type ShipmentLocationResponse = {
  /** 位置情報ID */
  locationId: string;
  /** 位置情報名 */
  locationName: string;
  /** 緯度 */
  latitude: number;
  /** 経度 */
  longitude: number;
  /** 郵便番号 */
  postalCode?: string;
  /** 住所 */
  address?: string;
  /** ジオメトリ */
  geometry?: ShipmentGeofenceDto;
  /** 配送もしくはルート設定で使用されている位置情報か */
  isUse?: boolean;
  /** 配送中のルート設定で使用されている位置情報か */
  isShipping?: boolean;
};

/** 配送位置情報の追加リクエスト内容 */
export type ShipmentLocationAddRequest = {
  /** 位置情報名 */
  locationName: string;
  /** 緯度 */
  latitude: number;
  /** 経度 */
  longitude: number;
  /** 郵便番号 */
  postalCode: string;
  /** 住所 */
  address: string;
  /** ジオメトリ */
  geometry: ShipmentGeofenceDto;
};

/** 配送位置情報の変更リクエスト内容 */
export type ShipmentLocationUpdateRequest = {
  /** 位置情報ID */
  locationId: string;
  /** 位置情報名 */
  locationName: string;
  /** 緯度 */
  latitude: number;
  /** 経度 */
  longitude: number;
  /** 郵便番号 */
  postalCode: string;
  /** 住所 */
  address: string;
  /** ジオメトリ */
  geometry: ShipmentGeofenceDto;
};

/** 配送位置情報インポートリクエスト内容 */
export type ImportShipmentLocationAddRequest = {
  /** 位置情報名 */
  locationName: string | null;
  /** 住所 */
  address: string | null;
  /** 経度 */
  longitude: number | null;
  /** 緯度 */
  latitude: number | null;
};

/** 配送位置情報インポート時のエラー情報 */
export type ShipmentLocationImportErrorResponse = {
  /** 位置情報名 */
  locationName: string | null;
  /** 住所 */
  address: string | null;
  /** 経度 */
  longitude: number | null;
  /** 緯度 */
  latitude: number | null;
  /** エラー理由 */
  errorReason: string;
};

/** 配送位置情報インポート時のレスポンス */
export type ShipmentLocationBulkImportResponse = {
  errorInvalidLocations: { [key: string]: ShipmentLocationImportErrorResponse };
  errorDuplicateLocations: {
    [key: string]: ShipmentLocationImportErrorResponse;
  };
  errorReverseGeocodeLocations: {
    [key: string]: ShipmentLocationImportErrorResponse;
  };
  errorGeofenceRegistrationLocations: {
    [key: string]: ShipmentLocationImportErrorResponse;
  };
};

/** 位置情報の場所候補 */
/** 配送位置情報一括削除リクエスト */
export type ShipmentLocationBulkDeleteRequest = {
  /** 配送位置情報ID一覧 */
  locationId: string[];
};

/** 配送位置情報一括削除レスポンス */
export type ShipmentLocationBulkDeleteResponse = {
  /** 削除成功した配送位置情報ID一覧 */
  successLocationIdList: string[];
  /** 削除失敗した配送位置情報ID一覧 */
  failedLocationIdList: string[];
};

export type ShipmentPlaceSuggestion = {
  /** テキスト */
  text: string;
  /** 場所ID */
  placeId: string;
};

/** 位置情報の場所情報 */
export type ShipmentPlace = {
  /** 緯度 */
  latitude: number;
  /** 経度 */
  longitude: number;
  /** 郵便番号 */
  postalCode?: string;
  /** 住所 */
  address: string;

  /** 以下、住所の詳細値 */
  addressNumber: string;
  street: string;
  neighborhood: string;
  municipality: string;
  subregion: string;
  region: string;
  country: string;
};
